export default "__VITE_ASSET__D1BSYxLA__"